import React, { PureComponent } from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

import IssuesTab from './IssuesTab';

const queryRelationshipsByType = gql`
  query Relationships($elementId: String, $typeId: String, $projectId: String) {
    relationshipsByType(elementId: $elementId, typeId: $typeId, projectId: $projectId) {
      id
      consumerElement {
        id
        name
      }
      consumer
      producer
      created_at
      project_id
      props
      type_id
    }
  }
`;

const withData = compose(
  graphql(queryRelationshipsByType, {
    options: ({ id, issueRelationshipTypeId, currentProjectId }) => ({
      variables: {
        elementId: id,
        typeId: issueRelationshipTypeId,
        projectId: currentProjectId,
      },
      fetchPolicy: 'network-only',
    }),
  })
);

@withData
class IssuesTabContainer extends PureComponent {
  static propTypes = {
  };
  
  render() {
    const { data: { relationshipsByType }} = this.props;

    if (!relationshipsByType) return null;

    return (
      <IssuesTab relationshipsByType={relationshipsByType} {...this.props} />
    );
  }
}

export default IssuesTabContainer;



// WEBPACK FOOTER //
// ./src/components/IssuesTab/IssuesTabContainer.js